import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { timer } from 'rxjs';
import { PaymentService } from '../../../../../core/services/payment.service';

@Component({
  selector: 'app-creditcard',
  templateUrl: './payment-credit-card.component.html',
  styleUrls: ['./payment-credit-card.component.scss']
})
export class PaymentCreditCardComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer, private router: Router, private paymentService: PaymentService) {

  }
  actionUrl: string = "";
  url: any;
  showLoading: boolean = true;
  ngOnInit() {
    this.transform();
    timer(4000)
      .subscribe(t => { this.showLoading = false });

  }
  transform() {
    this.actionUrl = this.paymentService.ccActionUrl;
    if (this.actionUrl) {
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.actionUrl);
      this.paymentService.ccActionUrl = "";//url will be used only once
    }
    else {
      this.router.navigate(['/invoice-inquiry/payment/review']);
    }
  }

  async completeTxn() {
    var request = { "trackerId": this.paymentService.ccTrackerId, "token": this.paymentService.ccRequestId };
    var paymentResponse = await this.paymentService.completeCreditCardPayment(request).toPromise();
    //alert(paymentResponse.message);
    this.router.navigate(['/invoice-inquiry/payment/review']);
  }
  async backToReview() {
    var request = {
      "trackerId": this.paymentService.ccTrackerId,
      "token": this.paymentService.ccRequestId,
      "userCancelled":"Y"
    };
    try {
      var paymentResponse = await this.paymentService.cancelCreditCardPayment(request).toPromise();
    }
    catch (e) {
      //dont do anything
    }
    this.router.navigate(['/invoice-inquiry/payment/review']);
  }
}
